import { createFileRoute } from '@tanstack/react-router'
import BppDashboardPage from '@/components/pages/backoffice/_dashboard/containers/BppDashboardPage'
import NewDashboardPage from '@/components/pages/backoffice/_dashboard/containers/NewDashboardPage'
import DashboardWelcome from '@/components/pages/backoffice/_dashboard/components/DashboardWelcome'
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList
} from '@/components/ui/breadcrumb'
import MaxWidthDiv from '@/components/ui/max-width-div'

export const Route = createFileRoute('/_backoffice/dashboard/')({
  component: RouteComponent,
  loader: ({ context: { profile } }) => {
    return { profile }
  }
})

function DashboardBreadcrumb() {
  return (
    <Breadcrumb>
      <BreadcrumbList>
        <BreadcrumbItem>
          <span className="text-sm font-medium text-gray-800">Dashboard</span>
        </BreadcrumbItem>
      </BreadcrumbList>
    </Breadcrumb>
  )
}

function RouteComponent() {
  const { profile } = Route.useLoaderData()
  const isPenyuluh = profile?.roles?.some(role => role.name === 'penyuluh')
  const isAdminBpp = profile?.roles?.some(role => role.name === 'admin_bpp')

  return (
    <MaxWidthDiv className="space-y-5">
      <DashboardBreadcrumb />
      <DashboardWelcome profile={profile} />
      {isPenyuluh && <NewDashboardPage />}
      {isAdminBpp && <BppDashboardPage />}
    </MaxWidthDiv>
  )
}
